import classNames from 'classnames';

import { useGlobalModalContext } from 'modal/useGlobalModalContext';
import GlobalModalInner from './GlobalModalInner';

const GlobalModal = () => {
  const { globalModalContent, handleGlobalModal, globalModalActive } =
    useGlobalModalContext();

  const wrapperClass = classNames('global-modal-wrapper', {
    'global-modal-wrapper--active': globalModalActive,
  });

  return globalModalActive ? (
    // data-nosnippet keeps the closed-store copy out of Google's search
    // snippets, which otherwise reads this modal as the page's main text
    <div className={wrapperClass} data-nosnippet>
      <GlobalModalInner {...globalModalContent} />
      <div
        className='global-modal-wrapper__overlay'
        onClick={(e) => {
          e.persist();
          handleGlobalModal();
        }}
      ></div>
    </div>
  ) : null;
};

export default GlobalModal;
